import LegalPage from "@/components/legal/LegalPage";

const Privacy = () => <LegalPage slug="privacy" />;

export default Privacy;
